export class AsyncTranslationLoader {
    static $inject = ['$locale'];
    constructor($locale) {
        return options => {
            const { key: locale } = options;
            return import(`./translationLoaders/${locale}.js`)
                .then(module => {
                const translations = module.default;
                // Update Angular's $locale service with the loaded locale data
                if (translations.DATETIME_FORMATS) {
                    Object.assign($locale.DATETIME_FORMATS, translations.DATETIME_FORMATS);
                }
                if (translations.NUMBER_FORMATS) {
                    Object.assign($locale.NUMBER_FORMATS, translations.NUMBER_FORMATS);
                }
                if (translations.id) {
                    $locale.id = translations.id;
                }
                if (translations.localeID) {
                    $locale.localeID = translations.localeID;
                }
                if (translations.pluralCat) {
                    $locale.pluralCat = translations.pluralCat;
                }
                return translations;
            });
        };
    }
}
AsyncTranslationLoader.$inject = ['$locale'];
